import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { firestore } from '../config/firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import './QuestaoDetails.css';

function QuestaoDetails() {
  const { id } = useParams(); // Obtendo o parâmetro da URL
  const [questao, setQuestao] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchQuestao = async () => {
      try {
        const docRef = doc(firestore, 'questoes', id); // Referência ao documento específico
        const docSnap = await getDoc(docRef); // Obtendo o documento
        if (docSnap.exists()) {
          setQuestao({ id: docSnap.id, ...docSnap.data() }); // Armazenando os dados da questão
          setFormData({ ...docSnap.data() }); // Configurando os dados do formulário
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Erro ao buscar questão:', error);
      } finally {
        setLoading(false); // Indicando que o carregamento foi concluído
      }
    };

    fetchQuestao(); // Chamada da função para buscar a questão ao montar o componente
  }, [id]); // Executando sempre que o parâmetro 'id' da URL mudar

  const handleEditToggle = () => {
    setIsEditing(!isEditing); // Alternando o modo de edição
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value }); // Atualizando os dados do formulário
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(firestore, 'questoes', id); // Referência ao documento específico
      const updatedData = {
        ...formData,
        updatedAt: new Date().toISOString(),
      };

      await updateDoc(docRef, updatedData); // Atualizando o documento no Firestore
      setQuestao({ ...questao, ...updatedData }); // Atualizando os dados da questão exibida
      setIsEditing(false); // Saindo do modo de edição
    } catch (error) {
      console.error('Erro ao atualizar questão:', error);
    }
  };

  const calculateCompletionPercentage = () => {
    const totalFields = Object.keys(formData).length;
    const filledFields = Object.values(formData).filter(value => value && value.trim() !== '').length;
    return Math.round((filledFields / totalFields) * 100); // Calculando a porcentagem de preenchimento do formulário
  };

  if (loading) return <p>Carregando...</p>; // Exibindo mensagem de carregamento enquanto os dados são obtidos

  const completionPercentage = calculateCompletionPercentage(); // Calculando a porcentagem de preenchimento

  return (
    <div className="questao-details">
      {questao ? (
        <>
          {isEditing ? (
            <form onSubmit={handleFormSubmit}>
              <h1>{questao.questionText ? 'Editar Questão' : 'Adicionar Nova Questão'}</h1>
              <label>
                Pergunta:
                <input
                  type="text"
                  name="questionText"
                  value={formData.questionText}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Categoria:
                <input
                  type="text"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Dificuldade:
                <select
                  name="difficulty"
                  value={formData.difficulty}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione</option>
                  <option value="fácil">Fácil</option>
                  <option value="médio">Médio</option>
                  <option value="difícil">Difícil</option>
                </select>
              </label>
              <button type="submit">Salvar</button>
              <button type="button" onClick={handleEditToggle}>Cancelar</button>
            </form>
          ) : (
            <>
              <h1>{questao.questionText}</h1>
              <div className="completion-bar">
                <div className="completion-bar-filled" style={{ width: `${completionPercentage}%` }}>
                  {completionPercentage}%
                </div>
              </div>
              <p><strong>Categoria:</strong> {questao.category}</p>
              <p><strong>Dificuldade:</strong> {questao.difficulty}</p>
              <button onClick={handleEditToggle}>Editar</button>
            </>
          )}
          
        </>
      ) : (
        <p>Questão não encontrada.</p>
      )}
    </div>
  );
}

export default QuestaoDetails;
